<template>
  <div>
    The drag coefficient <katex-element expression="C_D" /> of
                    the spacecraft represents the spacecraft's susceptibility to
                    drag forces.<br />
                    A typical value for a spacecraft is 2.2 or 2.3. <br />
                    The default value is 2.2.<br />
  </div>
</template>

<script>
export default {
  name: 'tooltipDragCoefficient'
}
</script>
